// Local translations
export const T = {
  en_GB: {
    displayMode: "Display Mode",
    rolling12Months: "Rolling 12 Months",
    calendarYear: "Calendar Year",
    rollingModeDesc:
      "Shows cost projections in rolling 12-month periods starting from the current date.",
    calendarModeDesc: "Shows cost projections aligned to calendar years (Jan-Dec).",
    chartType: "Chart Type",
    lineChart: "Line chart",
    barChart: "Bar chart",
  },
  nb_NO: {
    displayMode: "Visningsmodus",
    rolling12Months: "Rullerende 12 måneder",
    calendarYear: "Kalenderår",
    rollingModeDesc:
      "Viser kostnadsprojeksjoner i rullerende 12-måneders perioder fra nåværende dato.",
    calendarModeDesc: "Viser kostnadsprojeksjoner justert til kalenderår (jan-des).",
    chartType: "Diagramtype",
    lineChart: "Linjediagram",
    barChart: "Stolpediagram",
  },
} as const;
